<template>
    <!--用户登录-->
    <div class="login_register" v-wechat-title="title" :style="{height:height}">
        <div class='content'>
            <div class="main_title">{{ name }}</div>
            <!--<p>找到浩方源，幸福从这里开始</p>-->
            <section>
                <form action="">
                    <ul class='title'>
                        <li @click='toLogin()' :class="{active: type === 0}">登录</li>
                        <li @click='toRegister()' :class="{active: type === 1}">注册账号</li>
                    </ul>
                    <login v-show="type === 0"></login>
                    <register v-show='type === 1'></register>
                </form>
            </section>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	import Login from "../login/login";
	import Register from "../register/register";

	export default {
		data() {
			return {
				type: 0,
				name: '',
				title: '',
				height: '',
			};
		},
		components: {
			login: Login,
			register: Register,
		},
		created() {
			// console.log(window.screen.availHeight)
			this.height = window.screen.availHeight - 103 + 'px'
			this.name = localStorage.getItem('meta_title')
			// this.title = '登录 ' + localStorage.getItem('meta_title')
			this.title = '嘉联华 ' + '登录'
			window.addEventListener('setItem', () => {
				// console.log(localStorage.getItem('dealId'))
				this.type = Number(localStorage.getItem('login_type'));
			})
		},
		mounted() {
		},
		methods: {
			// toLogin(){
			// 	this.type = 0
			// 	this.$router.push({path:'/login'})
			// },
			toLogin() {
				this.type = 0
				this.title = '嘉联华 ' + '登录'
			},
			toRegister() {
				this.type = 1
				// this.$router.push({path: '/loginReg'})
				this.title = '嘉联华 ' + '注册'
			},
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
    .login_register {
        background: url("../../assets/images/bg/loginRegidter_bg.png") no-repeat;
        width: 100%;
        /*height: 100%;*/
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .content {
            display: flex;
            align-items: center;
            flex-direction: column;
            .main_title {
                font-size: 48px;
                text-align: center;
                font-family: MicrosoftYaHei-Bold;
                font-weight: bold;
                color: rgba(255, 255, 255, 1);
                margin-bottom: 20px;
            }
            p {
                font-size: 20px;
                text-align: center;
                color: rgba(255, 255, 255, 1);
                margin: 11px 0 21px;
            }
            section {
                width: 540px;
                background: rgba(255, 255, 255, 1);
                border-radius: 2px;
                form {
                    width: 380px;
                    margin: 0 auto;
                    ul {
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        width: 100%;
                        padding-top: 40px;
                        border-bottom: 1px solid rgba(214, 214, 214, 1);
                        li {
                            flex-grow: 1;
                            text-align: center;
                            font-size: 16px;
                            font-family: MicrosoftYaHei-Bold;
                            font-weight: bold;
                            color: rgba(51, 51, 51, 1);
                            line-height: 48px;
                            border-bottom: 2px solid transparent;
                            cursor: pointer;
                        }
                        li.active {
                            margin-bottom: -1px;
                            color: rgba(255, 174, 1, 1);
                            border-bottom: 2px solid rgba(255, 174, 1, 1);
                        }
                    }
                }
            }
        }
    }
</style>
